import React from "react";
import PropTypes from "prop-types";

import { getColor, getIcon, getEmbedPlatformLogo, isEmbeddedElement } from "utils/pageElements/helpers";

import Box from "@mui/material/Box";

const Icon = ({ type, image_url }) => {

  const isEmbedded = isEmbeddedElement(type);

  if (image_url || isEmbedded) {
    return (
      <img src={image_url || getEmbedPlatformLogo(type)} style={{ width: 30, height: 30 }} />
    );
  }

  return (
    <Box
      sx={{
        width: 30,
        height: 30,
        p: 1,
        borderRadius: 1,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: getColor(isEmbedded ? "embed" : type),
        color: "white",
      }}
    >
      {getIcon(isEmbedded ? "embed" : type)}
    </Box>
  );
};

Icon.propTypes = {
  type: PropTypes.string.isRequired,
  image_url: PropTypes.string,
};

export default Icon;
